export default __webpack_public_path__ + "static/icon-dropdown-product-smart-regs-5a2a0db97ee0a50127eaaab076852c9c.svg";